// categorys.js
// is_project: true  => ProjectCreate form-ல் show ஆகும்
// is_project இல்லாதது / false => PropertyCreate form மட்டும்

const categorys = [
  { id: 1,  type_id: [1],    category_name: "Apartment / Flat",  is_project: true  },
  { id: 2,  type_id: [2],    category_name: "Godown",            is_project: false },
  { id: 3,  type_id: [1],    category_name: "Villa",             is_project: true  },
  { id: 4,  type_id: [2],    category_name: "Office Space",      is_project: false },
  { id: 5,  type_id: [1, 2], category_name: "Plot / Land",       is_project: true  },
  { id: 6,  type_id: [1, 2], category_name: "Others", is_other: true, is_project: true },
];

export default categorys;